import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { event } from "react-ga";

export const StepFourComplete = ({ clinicianName, specimenCollectedDate, setSpecimenCollectedDate }) => {
  return (
    <div className="step-form">
      <h3>Complete</h3>
      <Form>
        <Form.Group controlId="formBasicSummary">
          <Form.Label>Ordering Physician</Form.Label>
          <Form.Control type="text" value={clinicianName} />
        </Form.Group>
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "10px"
          }}
        >
          <Form.Group controlId="formBasicSpecimenCollected">
            <Form.Label>Specimen Collected Date</Form.Label>
            <Form.Control type="date" value={specimenCollectedDate} onChange={e => setSpecimenCollectedDate(e.target.value)} />
          </Form.Group>
        </div>

        <div
          style={{
            marginTop: "20px"
          }}
        >
          <Form.Group controlId="formBasicSummary">
            {/* <Form.Check type="checkbox" label="Save as Draft" checked={isSaveAsDraft} onChange={handleSaveDraft}  className="form-check-ques" /> */}
          </Form.Group>
        </div>
      </Form>
    </div>
  );
};
